export enum ProbateSidenavTitle {
  HOME = 'Home',
  SUBSCRIBER = 'Subscriber',
  DECEDENT = 'Decedent',
  WILL = 'Will',
  HEIRS = 'Heirs',
  DOCUMENTS = 'Documents',
  ESTATE = 'Estate',
  BOND_SURETY = 'Bond/Surety',
  TAXES = 'Taxes',
  FORMS = 'Forms',
  NOTES = 'Notes',
  MESSAGES = 'Messages',
  HELP = 'Help',
}
